import { render, staticRenderFns } from "./DirectInvestmentValuationUpload.vue?vue&type=template&id=0d613b4f"
import script from "./DirectInvestmentValuationUpload.vue?vue&type=script&lang=js"
export * from "./DirectInvestmentValuationUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports